import { render, staticRenderFns } from "./VipRoom.vue?vue&type=template&id=7a398464&scoped=true"
import script from "./VipRoom.vue?vue&type=script&lang=js"
export * from "./VipRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a398464",
  null
  
)

export default component.exports